<template>
  <div class="left-box">
    <div class="">
      <div class="left-title d-aligncnter d-between" style="font-size: 22px">
        <div>各学院学期到课率</div>
        <div class="select-option">
          <el-select v-model="currTerm" placeholder="请选择" @change="changeTermData">
            <el-option v-for="item in termList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </div>
      </div>
      <div class="echarts">
        <div
          id="rate2"
          :style="{
            width: '800px',
            height: '440px',
            margin: '0 auto',
          }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['termAttendanceRate', 'termList'],
  data() {
    return {
      attendData: [],
      animatedTop: false,
      timer: null,
      flag: true,
      modeData: 0,
      option1: {},
      rateData: [90, 80, 99, 88, 99, 78, 90, 99, 88, 99, 78],
      rateDataDay: ['计算', '医学院', 'UW', '信电', '商学院', '外语学院', '传媒', '艺术与考古', '规划', '创意', '国旅'],
      currTerm: '',
    }
  },
  watch: {
    termAttendanceRate: {
      handler: function () {
        this.drawLineData(this.termAttendanceRate.rate)
      },
      deep: true,
    },
    termList: {
      handler: function () {
        this.currTerm = this.termList[0].id
        this.drawLineData(this.termAttendanceRate.rate)
      },
      deep: true,
    },
  },
  created() {
    this.currTerm = this.termList[0].id
  },
  mounted() {
    setTimeout(() => {
      var myChart1 = this.$echarts.init(document.getElementById('rate2'))
      myChart1.setOption(this.option1)
    }, 6000)
    this.drawLineData(this.termAttendanceRate.rate)
    window.onresize = () => {
      return (() => {
        this.drawLineData(this.termAttendanceRate.rate)
      })()
    }
  },
  computed: {},
  methods: {
    drawLineData(data) {
      var myChart1 = this.$echarts.init(document.getElementById('rate2'))
      this.option1 = {
        tooltip: {},
        grid: {
          top: '4%',
          bottom: '22%',
        },
        xAxis: {
          axisLabel: {
            interval: 0,

            rotate: 20,
          },
          type: 'category',
          boundaryGap: true,
          //   axisLabel: { interval: 0, rotate: 30 },
          data: this.termAttendanceRate.college,
          axisTick: {
            alignWithLabel: true,
          },
        },
        axisLabel: {
          color: '#339571',
        },
        yAxis: {
          minInterval: 20,
          axisLine: {
            show: true, //是否显示轴线
            lineStyle: {
              color: '#339571', //刻度线的颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: '#339571',
            },
          },
        },
        series: [
          {
            name: '时间',
            type: 'bar',
            // areaStyle: {},
            data: data,
            label: {
              show: true,
              position: 'top',
              formatter: '{c}%',
            },
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFB612' },
                { offset: 1, color: '#4DA282' },
              ]),
            },
          },
        ],
      }
      myChart1.setOption(this.option1)
    },

    changeTermData(e) {
      console.log('changeTermData:', e)
      this.$emit('changeTerm', e, 'center')
    },
  },
}
</script>
<style scoped lang="scss">
.num {
  font-size: 1rem;
  margin-top: 8px;
  color: #339571;
  font-weight: 600;
}
.echarts {
  margin-left: calc(24px - 6%);
  height: 477px;
  margin-top: 0px;
}

.select-option ::v-deep .el-input__inner,
.el-select-dropdown__item.is-disabled:hover {
  background-color: rgba(255, 255, 255, 0) !important;
}
.select-option ::v-deep .el-input__inner {
  //   border: 1px solid #007a4d !important;
  height: 36px;
  color: #fff;
  width: 205px;
  border: none;
  text-align: right;
  //   padding-right: 16px !important;
}
.select-option ::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 105px;
}
.select-option ::v-deep .el-input__icon {
  line-height: 36px;
}
</style>
